module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Gardens of Deprivation")]), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#about-the-author"
    }
  }, [_vm._v("About the Author")])]), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#dedication"
    }
  }, [_vm._v("Dedication")])]), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#copyright-information"
    }
  }, [_vm._v("Copyright Information ©")])]), _c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch004#acknowledgement"
    }
  }, [_vm._v("Acknowledgement")])]), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch005#biography"
    }
  }, [_vm._v("Biography")])]), _c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch006#preface"
    }
  }, [_vm._v("Preface")])]), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch007#part-1-brown-tales-from-my-land-of-origin"
    }
  }, [_vm._v("Part 1: Brown Tales from My Land of Origin")])]), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch008#my-land-and-people-of-origin"
    }
  }, [_vm._v("My Land and People of Origin")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch009#intrinsic-bond-and-imminent-expulsion"
    }
  }, [_vm._v("1. Intrinsic Bond and Imminent Expulsion")])]), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch010#the-connecting-old-book"
    }
  }, [_vm._v("2. The Connecting Old Book")])]), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch011#my-preferred-pilgrimage-and-its-scope"
    }
  }, [_vm._v("3. My Preferred Pilgrimage and Its Scope")])]), _c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch012#cultural-insensitivity-and-favouritism"
    }
  }, [_vm._v("4. Cultural Insensitivity and Favouritism")])]), _c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch013#a-blocked-road-for-the-best-vehicle-of-reintegration"
    }
  }, [_vm._v("5. A Blocked Road for the Best Vehicle of Reintegration")])]), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch014#where-were-the-moral-guardians"
    }
  }, [_vm._v("6. Where Were the Moral Guardians?")])]), _c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch015#identity-and-mission"
    }
  }, [_vm._v("7. Identity and Mission")])]), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch016#the-historical-visionary-leader-lawmaker-and-role-model"
    }
  }, [_vm._v("8. The Historical Visionary, Leader, Lawmaker and Role-Model")])]), _c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch017#conceived-in-sin-and-born-with-greed-in-a-lions-den"
    }
  }, [_vm._v("9. Conceived in Sin and Born with Greed in a Lion’s Den")])]), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch018#a-holy-nation"
    }
  }, [_vm._v("10. A Holy Nation?")])]), _c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch019#on-a-road-to-armageddon"
    }
  }, [_vm._v("11. On a Road to Armageddon")])]), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch020#the-treaties"
    }
  }, [_vm._v("12. The Treaties")])]), _c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch021#the-mood-morale-and-moral"
    }
  }, [_vm._v("13. The Mood, Morale and Moral")])]), _c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch022#just-in-case-foreign-passports"
    }
  }, [_vm._v("14. Just-in-Case Foreign Passports")])]), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch023#a-necessary-exodus-to-an-island"
    }
  }, [_vm._v("15. A Necessary Exodus to an Island")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch024#childhood"
    }
  }, [_vm._v("1950–1963: Childhood")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch025#born-in-yafo-with-tamar"
    }
  }, [_vm._v("16. Born in Yafo with Tamar")])]), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch026#early-childhood-with-orly"
    }
  }, [_vm._v("17. Early Childhood with Orly")])]), _c('li', {
    attrs: {
      "id": "toc-li-27"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch027#my-best-friend-gibraltar",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18. My Best Friend Gibraltar")])]), _c('li', {
    attrs: {
      "id": "toc-li-28"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch028#the-village-and-the-garden",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19. The Village and the Garden")])]), _c('li', {
    attrs: {
      "id": "toc-li-29"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch029#biblical-and-history-lessons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20. Biblical and History Lessons")])]), _c('li', {
    attrs: {
      "id": "toc-li-30"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch030#rejoice-azor-not-you-yazur",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21. Rejoice Azor! Not You, Yazur!")])]), _c('li', {
    attrs: {
      "id": "toc-li-31"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch031#the-assembled-outcasts",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22. The Assembled Outcasts")])]), _c('li', {
    attrs: {
      "id": "toc-li-32"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch032#in-sacred-memory",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23. In Sacred Memory")])]), _c('li', {
    attrs: {
      "id": "toc-li-33"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch033#a-spirited-mother",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24. A Spirited Mother")])]), _c('li', {
    attrs: {
      "id": "toc-li-34"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch034#a-diligent-father",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25. A Diligent Father")])]), _c('li', {
    attrs: {
      "id": "toc-li-35"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch035#an-uncle-with-a-peculiar-friend",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26. An Uncle with a Peculiar Friend")])]), _c('li', {
    attrs: {
      "id": "toc-li-36"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch036#education-at-home",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27. Education at Home")])]), _c('li', {
    attrs: {
      "id": "toc-li-37"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch037#musical-education",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28. Musical Education")])]), _c('li', {
    attrs: {
      "id": "toc-li-38"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch038#the-village-primary-school",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29. The Village Primary School")])]), _c('li', {
    attrs: {
      "id": "toc-li-39"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch039#a-discriminatory-and-violent-headmaster",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30. A Discriminatory and Violent Headmaster")])]), _c('li', {
    attrs: {
      "id": "toc-li-40"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch040#the-first-generation-children",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31. The First-Generation Children")])]), _c('li', {
    attrs: {
      "id": "toc-li-41"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch041#the-old-seductive-land-and-her-admirers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32. The Old Seductive Land and Her Admirers")])]), _c('li', {
    attrs: {
      "id": "toc-li-42"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch042#an-unholy-industry",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33. An Unholy Industry")])]), _c('li', {
    attrs: {
      "id": "toc-li-43"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch043#banjars-legacy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34. Banjar’s Legacy")])]), _c('li', {
    attrs: {
      "id": "toc-li-44"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch044#a-dream-machine",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35. A Dream Machine")])]), _c('li', {
    attrs: {
      "id": "toc-li-45"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch045#a-greenie-ahead-of-his-time",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36. A Greenie Ahead of His Time")])]), _c('li', {
    attrs: {
      "id": "toc-li-46"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch046#karma-a-land-that-devours-its-inhabitants",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37. Karma? A Land that Devours Its Inhabitants?")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-47"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch047#adolescence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1964–1968: Adolescence")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-48"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch048#a-young-construction-worker",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38. A Young Construction Worker")])]), _c('li', {
    attrs: {
      "id": "toc-li-49"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch049#limited-horizons",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39. Limited Horizons")])]), _c('li', {
    attrs: {
      "id": "toc-li-50"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch050#high-school-pearls",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40. High-School Pearls")])]), _c('li', {
    attrs: {
      "id": "toc-li-51"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch051#hiydeh-maccabi-yafo",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41. Hi’ydeh Maccabi Yafo!")])]), _c('li', {
    attrs: {
      "id": "toc-li-52"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch052#youth-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42. Youth Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-53"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch053#khoranim-upon-you-israel",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43. Khoranim Upon You, Israel!")])]), _c('li', {
    attrs: {
      "id": "toc-li-54"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch054#public-failures-call-for-private-initiatives",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44. Public Failures Call for Private Initiatives")])]), _c('li', {
    attrs: {
      "id": "toc-li-55"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch055#local-and-national-transformations",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45. Local and National Transformations")])]), _c('li', {
    attrs: {
      "id": "toc-li-56"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch056#the-khoranims-sprinklers-spun-us-to-war",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46. The Khoranim’s Sprinklers Spun Us to War")])]), _c('li', {
    attrs: {
      "id": "toc-li-57"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch057#an-independence-day-present",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47. An Independence Day Present")])]), _c('li', {
    attrs: {
      "id": "toc-li-58"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch058#salvation-by-a-lucky-strike-and-unsung-heroes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48. Salvation by a Lucky Strike and Unsung Heroes")])]), _c('li', {
    attrs: {
      "id": "toc-li-59"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch059#a-lone-tank-at-the-foot-of-the-hill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49. A Lone Tank at the Foot of the Hill")])]), _c('li', {
    attrs: {
      "id": "toc-li-60"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch060#yeshurun-grew-fat-and-kicked",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50. Yeshurun Grew Fat and Kicked")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-61"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch061#military-service",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1969–1971: Military Service")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-62"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch062#sour-mau-mau-companys-sweat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51. Sour Mau-Mau Company’s Sweat")])]), _c('li', {
    attrs: {
      "id": "toc-li-63"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch063#sweet-squad-commanders-sweat",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52. Sweet Squad-Commanders’ Sweat")])]), _c('li', {
    attrs: {
      "id": "toc-li-64"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch064#sacrificed-lambs",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53. Sacrificed Lambs")])]), _c('li', {
    attrs: {
      "id": "toc-li-65"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch065#welcome-to-the-war-of-attrition",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54. Welcome to the War of Attrition")])]), _c('li', {
    attrs: {
      "id": "toc-li-66"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch066#a-trip-to-hell",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55. A Trip to Hell")])]), _c('li', {
    attrs: {
      "id": "toc-li-67"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch067#a-hot-air-balloon",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56. A Hot Air Balloon")])]), _c('li', {
    attrs: {
      "id": "toc-li-68"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch068#the-tiger-in-the-cabrit-inferno",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57. The Tiger in the Cabrit Inferno")])]), _c('li', {
    attrs: {
      "id": "toc-li-69"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch069#a-cabin-at-the-foot-of-the-hill",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58. A Cabin at the Foot of the Hill")])]), _c('li', {
    attrs: {
      "id": "toc-li-70"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch070#the-prisoner",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59. The Prisoner")])]), _c('li', {
    attrs: {
      "id": "toc-li-71"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch071#a-lucky-encounter-with-a-bull",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60. A Lucky Encounter with a Bull")])]), _c('li', {
    attrs: {
      "id": "toc-li-72"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch072#first-taste-of-love",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61. First Taste of Love")])]), _c('li', {
    attrs: {
      "id": "toc-li-73"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch073#providence",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62. Providence")])]), _c('li', {
    attrs: {
      "id": "toc-li-74"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch074#the-writing-on-the-wall",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63. The Writing on the Wall")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-75"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch075#from-construction-to-phd",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1972–1981: From Construction to PhD")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-76"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch076#blue-and-white-and-hard-work",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64. Blue-and-White and Hard Work")])]), _c('li', {
    attrs: {
      "id": "toc-li-77"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch077#a-real-jewelnot-an-akhsa",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65. A Real Jewel—Not an Akhsa")])]), _c('li', {
    attrs: {
      "id": "toc-li-78"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch078#the-heavy-war",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66. The Heavy War")])]), _c('li', {
    attrs: {
      "id": "toc-li-79"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch079#irresponsible-reliance-on-three-percent",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67. Irresponsible Reliance on Three Percent")])]), _c('li', {
    attrs: {
      "id": "toc-li-80"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch080#an-unsung-singing-tarzan",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68. An Unsung Singing Tarzan")])]), _c('li', {
    attrs: {
      "id": "toc-li-81"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch081#a-king-for-a-naked-nation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69. A King for a Naked Nation")])]), _c('li', {
    attrs: {
      "id": "toc-li-82"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch082#too-late-an-offer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70. Too Late an Offer")])]), _c('li', {
    attrs: {
      "id": "toc-li-83"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch083#a-divided-house",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71. A Divided House")])]), _c('li', {
    attrs: {
      "id": "toc-li-84"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch084#the-quarter-man-gdaliahs-transformation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72. The Quarter-Man-Gdaliahs’ Transformation")])]), _c('li', {
    attrs: {
      "id": "toc-li-85"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch085#sheikh-munis-ivory-tower",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73. Sheikh Munis’ Ivory Tower")])]), _c('li', {
    attrs: {
      "id": "toc-li-86"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch086#the-water-authoritys-sewage",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74. The Water Authority’s Sewage")])]), _c('li', {
    attrs: {
      "id": "toc-li-87"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch087#heavenly-berkeley",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75. Heavenly Berkeley")])]), _c('li', {
    attrs: {
      "id": "toc-li-88"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch088#gibraltars-choice",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76. Gibraltar’s Choice")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-89"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch089#early-academic-service",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1982–1990: Early Academic Service")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-90"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch090#from-the-bay-area-to-the-negev",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77. From the Bay Area to the Negev")])]), _c('li', {
    attrs: {
      "id": "toc-li-91"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch091#academic-evaluations-and-promotions",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78. Academic Evaluations and Promotions")])]), _c('li', {
    attrs: {
      "id": "toc-li-92"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch092#how-fair-are-your-tents-o-jacob",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79. How Fair Are Your Tents, O Jacob")])]), _c('li', {
    attrs: {
      "id": "toc-li-93"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch093#flying-stones",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80. Flying Stones")])]), _c('li', {
    attrs: {
      "id": "toc-li-94"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch094#a-painful-decision",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81. A Painful Decision")])]), _c('li', {
    attrs: {
      "id": "toc-li-95"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch095#a-colour-blind-charmer",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82. A Colour-Blind Charmer")])]), _c('li', {
    attrs: {
      "id": "toc-li-96"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch096#trespassers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83. Trespassers")])]), _c('li', {
    attrs: {
      "id": "toc-li-97"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch097#exodus",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84. Exodus")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-98"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch098#part-2-brown-tales-from-my-chosen-land",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: Brown Tales from my Chosen Land")])]), _c('li', {
    attrs: {
      "id": "toc-li-99"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch099#welcome-to-a-white-australia-fortress",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1990–1997: Welcome to a White Australia Fortress")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-100"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch100#to-australia-by-the-anzac-bridge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85. To Australia by the ANZAC Bridge")])]), _c('li', {
    attrs: {
      "id": "toc-li-101"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch101#the-cost",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86. The Cost")])]), _c('li', {
    attrs: {
      "id": "toc-li-102"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch102#the-blocked-bridge",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87. The Blocked Bridge")])]), _c('li', {
    attrs: {
      "id": "toc-li-103"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch103#the-double-appointments-trap",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88. The Double-Appointment’s Trap")])]), _c('li', {
    attrs: {
      "id": "toc-li-104"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch104#old-boys-clubs-wheeling-and-dealing",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89. Old Boys Club’s Wheeling and Dealing")])]), _c('li', {
    attrs: {
      "id": "toc-li-105"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch105#reciprocated-derailment",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90. Reciprocated Derailment")])]), _c('li', {
    attrs: {
      "id": "toc-li-106"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch106#small-town-blues",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91. Small Town Blues")])]), _c('li', {
    attrs: {
      "id": "toc-li-107"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch107#a-kangaroo-courts-condemnation",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92. A Kangaroo-Court’s Condemnation")])]), _c('li', {
    attrs: {
      "id": "toc-li-108"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch108#a-forgone-opportunity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93. A Forgone Opportunity")])]), _c('li', {
    attrs: {
      "id": "toc-li-109"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch109#you-are-so-brown",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94. You Are So Brown")])]), _c('li', {
    attrs: {
      "id": "toc-li-110"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch110#for-whom-the-bell-tolls",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95. For Whom the Bell Tolls")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-111"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch111#the-welcomes-spillover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1998–2002: The Welcome’s Spillover")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-112"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch112#do-you-know-what-your-problem-is",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96. Do You Know What Your Problem Is?")])]), _c('li', {
    attrs: {
      "id": "toc-li-113"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch113#the-collapse-of-the-nest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97. The Collapse of the Nest")])]), _c('li', {
    attrs: {
      "id": "toc-li-114"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch114#a-home-hit-by-cyclones-stood-up",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98. A Home Hit by Cyclones Stood Up")])]), _c('li', {
    attrs: {
      "id": "toc-li-115"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch115#the-aftermath-and-its-cherubim",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99. The Aftermath and Its Cherubim")])]), _c('li', {
    attrs: {
      "id": "toc-li-116"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch116#a-divorcees-lot",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100. A Divorcee’s Lot")])]), _c('li', {
    attrs: {
      "id": "toc-li-117"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch117#inappropriate-unfair-and-harmful-appointments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101. Inappropriate, Unfair and Harmful Appointments")])]), _c('li', {
    attrs: {
      "id": "toc-li-118"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch118#street-smarts-beauty-contest",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102. Street-Smarts’ Beauty Contest")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-119"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch119#tender-east-and-harsh-west",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2003–2005: Tender East and Harsh West")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-120"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch120#tender-charm-and-the-bright-apple-of-my-eye",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103. Tender Charm and the Bright Apple of My Eye")])]), _c('li', {
    attrs: {
      "id": "toc-li-121"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch121#no-man-is-a-prophet-in-his-town",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104. No Man is a Prophet in His Town")])]), _c('li', {
    attrs: {
      "id": "toc-li-122"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch122#a-full-professor-vagabond-in-the-big-apple",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105. A Full-Professor Vagabond in the Big Apple")])]), _c('li', {
    attrs: {
      "id": "toc-li-123"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch123#whats-wrong-with-whom",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106. What’s Wrong with Whom?")])]), _c('li', {
    attrs: {
      "id": "toc-li-124"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch124#a-bloody-volvo-driver",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107. A Bloody Volvo Driver")])]), _c('li', {
    attrs: {
      "id": "toc-li-125"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch125#homecoming",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108. Homecoming")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-126"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch126#back-in-the-garden-of-thorns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2006–2015: Back in the Garden of Thorns")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-127"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch127#a-rose-among-the-thorns",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109. A Rose Among the Thorns")])]), _c('li', {
    attrs: {
      "id": "toc-li-128"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch128#bds-ed",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110. BDS-ed")])]), _c('li', {
    attrs: {
      "id": "toc-li-129"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch129#enough-is-enough",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111. Enough is Enough")])]), _c('li', {
    attrs: {
      "id": "toc-li-130"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch130#forsaken",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112. Forsaken")])]), _c('li', {
    attrs: {
      "id": "toc-li-131"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch131#still-chipping-a-way",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113. Still Chipping a Way")])]), _c('li', {
    attrs: {
      "id": "toc-li-132"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch132#trusted-by-the-floor-but-distrusted-by-the-ceiling",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114. Trusted by the Floor but Distrusted by the Ceiling")])]), _c('li', {
    attrs: {
      "id": "toc-li-133"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch133#graceful-retirement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115. Graceful Retirement")])]), _c('li', {
    attrs: {
      "id": "toc-li-134"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch134#sincere-acknowledgement",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116. Sincere Acknowledgement")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-135"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch135#first-golden-years",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2016–2021: First Golden Years")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-136"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch136#realised-identity",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117. Realised Identity")])]), _c('li', {
    attrs: {
      "id": "toc-li-137"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch137#preferred-identity-and-location",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118. Preferred Identity and Location")])]), _c('li', {
    attrs: {
      "id": "toc-li-138"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch138#partnership",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119. Partnership")])]), _c('li', {
    attrs: {
      "id": "toc-li-139"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch139#aloneness-loneliness-and-happiness",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120. Aloneness, Loneliness and Happiness")])]), _c('li', {
    attrs: {
      "id": "toc-li-140"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch140#in-a-valley-shadowed-by-a-deadly-pandemic",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("121. In a Valley Shadowed by a Deadly Pandemic")])])])]), _c('li', {
    attrs: {
      "id": "toc-li-141"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch141#references",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("References")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 60
// module chunks = 0